import BuilderModel from "~/models/tracked/builderModel";
import Repo from "~/state/modules/repo";
import IRepo from "~/interfaces/repo";
import Guid from "~/helpers/guid";
import Vue from "vue";
import ObjectModelEntry from "~/models/objectModelEntries/objectModelEntry";
import DatetimeHelper from "~/helpers/datetimeHelper";
import ListViewFilterElement from "~/models/listViews/elements/listViewFilterElement";
import ObjectModelRelation from "~/models/objectModelRelations/objectModelRelation";
import {
  ObjectModelBuiltinPropertyType,
  ObjectModelBuiltinPropertyTypeName
} from "~/enums/objectModelBuiltinPropertyType";

export default class ObjectModelDefaultPropertyReference extends BuilderModel{
  type: ObjectModelBuiltinPropertyType;
  model_id: string;


  static repo: IRepo<ObjectModelDefaultPropertyReference> = new Repo<ObjectModelDefaultPropertyReference>('objectModelDefaultPropertyReferences', ObjectModelDefaultPropertyReference);

  except = ['fieldName'];

  constructor(parent: ObjectModelRelation | ListViewFilterElement, private fieldName: string, json: any = {}) {
    super();
    this.defineProperty('client_id', json['client_id'] || Guid.create());
    this.defineProperty('type', json['type']);
    this.defineProperty('model_id', json['model_id']);

    this.fieldName = fieldName;
    this.nameInParent = fieldName;
    this.parent = parent;
    this.rootModel = parent.rootModel;

    this.loadFromJson(json, this.rootModel);

    ObjectModelDefaultPropertyReference.repo.add(this);
  }
  get label_title(): string {
    return ObjectModelBuiltinPropertyTypeName[this.type]
  }

  defaultPropertyValueForEntry(entry: ObjectModelEntry){
    switch (this.type) {
      case ObjectModelBuiltinPropertyType.RecordHolderName:
        return entry?.object_model_holder_name;
      case ObjectModelBuiltinPropertyType.CreatedAt:
        return DatetimeHelper.toTimeString(entry?.c_at);
      case ObjectModelBuiltinPropertyType.CreatedBy:
        return entry?.creator?.name;
      case ObjectModelBuiltinPropertyType.UpdatedAt:
        return DatetimeHelper.toTimeString(entry?.u_at);
      case ObjectModelBuiltinPropertyType.RecordHolderEmail:
        return entry?.owner?.email;

    }
  }


  get rootName(): string {
    return this.fieldName
  }

}